import React, { useState, useEffect } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, FormGroup, Card, CardBody, ListGroupItem, ListGroup, ModalHeader, ModalFooter, } from 'reactstrap';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import DualListBox from "react-dual-listbox";
import * as reducerPosition from '../../../../slices/position/reducer';
import { addNewPosition, updatePosition } from '../../../../slices/position/thunk';
import { getPositionTypeList, getResidueCategoryList, getTreatmentDetailList, getTreatmentList } from '../../../../helpers/residue/backend_helper';
import { useLoading } from '../../../../Context/LoadingContext';
import OSelect from '../../../../Components/OElements/OSelect';
import SimpleBar from 'simplebar-react';
import validateRUT from '../../../../helpers/utils/validateRUT';
import { getItemGroupList, getPersonList, getWarehouseItemList } from '../../../../slices/thunks';
import AssignationPersonsPosition from '../Components/AssignationPersonsPosition/AssignationPersonsPosition';
import AssignationPPEPosition from '../Components/AssignationPPEPosition/AssignationPPEPosition';
import PositionItemsTable from '../Components/PositionItemsTable.js/PositionItemsTable';


const PositionForm = ({ dataPosition, isEdit, handleToggleModal, isOpen, activeTab, toggleTab, }) => {
    const { openLoading, closeLoading } = useLoading();
    const dispatch = useDispatch();
    const [selectedItems, setSelectedItems] = useState([]);
    const [itemsList, setItemsList] = useState([]);
    const [personsList, setPersonsList] = useState([]);

    const selectorPosition = createSelector(
        state => state.Positions,
        position => ({
            isAdding: position.isAdding,
            isAdded: position.isAdded,
            isUpdating: position.isUpdating,
            isUpdated: position.isUpdated,
            isLoadingList: position.isLoadingList,
            requireCloseModalPosition: position.requireCloseModal
        })
    );

    const {
        isAdding,
        isAdded,
        isUpdating,
        isUpdated,
        isLoadingList,
        requireCloseModalPosition,
    } = useSelector(selectorPosition);

    const isAddingAssignation = false;

    // validation
    const validation = useFormik({
        // enableReinitialize: use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            name: dataPosition.name || '',
            disabled: dataPosition.disabled,
            person_ids: dataPosition.person_ids ? dataPosition.person_ids : [],
            item_ids: dataPosition.item_ids ? dataPosition.item_ids : [],
            items_position: dataPosition.items_position ? dataPosition.items_position : [],
        },
        validationSchema: Yup.object({
            name: Yup
                .string()
                .required('Campo requerido'),
            person_ids: Yup
                .array()
                .of(Yup.string()),
            item_ids: Yup
                .array()
                .of(Yup.string()),
            items_position: Yup.array().of(
                Yup.object({
                    item_group_id: Yup.string().required(),
                    quantity: Yup.number().min(1).required()
                })
            ),
        }),
        onSubmit: async (values) => {
            handleToggleModal();
            openLoading();
            try {
                if (isEdit) {
                    const updatedPosition = {
                        _id: dataPosition._id,
                        ...validation.values
                    };

                    try {
                        const response = await dispatch(updatePosition(updatedPosition)).unwrap();
                        handleToggleModal();
                    } catch (error) {
                        console.error(error);
                    }
                } else {
                    const newPosition = {
                        ...validation.values
                    };

                    try {
                        const response = await dispatch(addNewPosition(newPosition)).unwrap();
                        handleToggleModal();
                    } catch (error) {
                        console.error(error);
                    }
                }
            }
            finally {
                closeLoading();
            }
        },
    });

    const loadListItems = async () => {
        try {
            const response = await dispatch(getItemGroupList()).unwrap();
            const seen = new Set();
            const itemsListFinal = response
                .map(item => ({ value: item._id, name: item.name }))

            setItemsList(itemsListFinal);

        } catch (err) {
            console.log(err.message);
        }
    };

    const loadPersonList = async () => {
        try {
            const response = await dispatch(getPersonList()).unwrap();
            const personsListFinal = response
                .map(item => ({ value: item._id, rut: item?.rut, name: item?.name }))
            setPersonsList(personsListFinal);

        } catch (err) {
            console.log(err.message);
        }
    };

    useEffect(() => {
        loadListItems();
        loadPersonList();
    }, [])

    const handleRowSelectionChange = (itemsWithQuantity) => {
        validation.setFieldValue('items_position', itemsWithQuantity);
    };

    return (
        <React.Fragment>
            <Form
                className='tablelist-form'
                onSubmit={e => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                }}
            >
                <ModalBody>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId='1'>
                            <Row className='g-3'>
                                <Col lg={4}>
                                    <Label for='name' className='form-label'>
                                        Nombre
                                    </Label>
                                    <Input
                                        name='name'
                                        id='name'
                                        className='form-control'
                                        placeholder='Ingrese un nombre'
                                        type='text'
                                        validate={{ required: { value: true } }}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.name || ''}
                                        invalid={
                                            validation.touched.name &&
                                                validation.errors.name
                                                ? true
                                                : false
                                        }
                                    />
                                    {
                                        validation.touched.name &&
                                            validation.errors.name ? (
                                            <FormFeedback type='invalid'>
                                                {validation.errors.name}
                                            </FormFeedback>
                                        ) : null
                                    }
                                </Col>
                            </Row>
                        </TabPane>
                        <TabPane tabId='2'>
                            <div className="row">
                                <div className="col-lg-12">
                                    <SimpleBar style={{ maxHeight: "400px" }}>
                                        <AssignationPersonsPosition
                                            position={dataPosition}
                                            personsList={personsList}
                                            validation={validation}
                                        />
                                    </SimpleBar>
                            
                                </div>
                            </div>
                        </TabPane>
                        <TabPane tabId='3'>
                            <div className="row">
                                <div className="col-lg-12" style={{ maxHeight: "500px", overflowY: "auto" }}>
                                    <div className="col-lg-12">
                                        <AssignationPPEPosition
                                            position={dataPosition}
                                            itemsList={itemsList}
                                            validation={validation}
                                        />
                                        <PositionItemsTable 
                                            items={itemsList} 
                                            itemsSelectedIds={validation.values.item_ids}
                                            itemsPosition={validation.values.items_position}
                                            onRowSelectionChange={handleRowSelectionChange}
                                        /> 
                                    </div>
                                </div>
                            </div>
                        </TabPane>
                    </TabContent>
                </ModalBody>
                <ModalFooter>
                    <div className='hstack gap-2 justify-content-end'>
                        <Button
                            type='button'
                            onClick={() => {
                                handleToggleModal();
                            }} className='btn-danger btn-label'>
                            <i className="ri-close-line label-icon"></i>
                            Cancelar
                        </Button>
                        <button
                            type='submit'
                            className='btn btn-label btn-primary'
                            id='add-btn'
                            disabled={isAdding || isUpdating || isAddingAssignation}
                        >
                            {isAdding || isUpdating || isAddingAssignation ? (
                                <i className='label-icon'><Spinner size='sm' /></i>
                            ) : <i className="ri-save-3-line label-icon"></i>}
                            {isEdit ? 'Editar' : 'Crear'} Cargo
                        </button>
                    </div>
                </ModalFooter>
            </Form>
        </React.Fragment>
    );
};

export default PositionForm;
